import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServicesRoutingModule } from './services-routing.module';
import { TrackingStepComponent } from './tracking-step/tracking-step.component';
import { ServicesTrackingComponent } from './services-tracking/services-tracking.component';
import { ServicesPaymentComponent } from './services-payment/services-payment.component';
import { ServicesTicketComponent } from './services-ticket/services-ticket.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCoreModule } from '@shared/material/mat-core.module';
import { SharedModule } from '@shared/shared.module';
import { ServicesListComponent } from './services-list/services-list.component';
import { ServicesComponent } from './services.component';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import {MatTableModule} from '@angular/material/table';


@NgModule({
  declarations: [
    TrackingStepComponent,
    ServicesTrackingComponent,
    ServicesPaymentComponent,
    ServicesTicketComponent,
    ServicesListComponent,
    ServicesComponent
  ],
  imports: [
    CommonModule,
    ServicesRoutingModule,
    SharedModule,
    MatCoreModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    CdkAccordionModule,
    MatTableModule,
  ],
  // schemas: [
  //   ServicesListComponent
  // ],
})
export class ServicesModule { }
